module.exports = __webpack_public_path__ + "static/media/Tarmika.da5372fc.svg";